import { Contactpersoon } from "@/entities/contactpersoon";
import { MedewerkersOpStationDto, MolDto, VosDto } from "@/shared/types";

export type VosStationStatus = "NietAangevraagd" | "AanvraagLoopt" | "VosIngezet" | "GeenVosInzetbaar" | "Gestopt";

export type MedewerkersOpStation = {
    stationCode: string;
    bemenst: boolean;
    veilig: boolean;
    aantalBeschikbareVossen: number;
    status: VosStationStatus;
    vossen: Vos[];
    mollen: Mol[];
};

export const MedewerkersOpStation = {
    fromDto: (dto: MedewerkersOpStationDto): MedewerkersOpStation => ({
        stationCode: dto.stationcode,
        bemenst: dto.bemenst,
        veilig: dto.veilig,
        aantalBeschikbareVossen: dto.aantalBeschikbareVossen,
        status: dto.status,
        vossen: dto.vossen.map((vos) => Vos.fromDto(vos)),
        mollen: dto.mollen.map((mol) => Mol.fromDto(mol)),
    }),
};

export type Vos = {
    contactpersoon: Contactpersoon;
    status: "Geaccepteerd" | "Gestopt";
};

const Vos = {
    fromDto: (dto: VosDto): Vos => ({
        contactpersoon: Contactpersoon.fromDto(dto.contactpersoon),
        status: dto.status,
    }),
};

export type Mol = {
    contactpersoon: Contactpersoon;
};

const Mol = {
    fromDto: (dto: MolDto): Mol => ({
        contactpersoon: Contactpersoon.fromDto(dto.contactpersoon),
    }),
};

export const Medewerker = {
    isVos: (medewerker: Vos | Mol): medewerker is Vos => {
        return "status" in medewerker;
    },
};
